/**
 * DivergingBars — polarity around zero (dataviz: "in vs out → diverging bars").
 * Used for the hero's "נכנס מול יצא" per period: one shared scale, a single zero axis,
 * direct value labels (no legend needed — the two directions are labelled in place) and a
 * table twin. Colour is never the only cue: the sign and the side of zero carry the meaning.
 */

import { fmtMoney } from '../format.ts';
import { Figure, type TableTwin } from './Figure.tsx';

export interface DivergingRow {
  label: string;
  /** agorot, positive = in, negative = out. */
  value: number;
}

export function DivergingBars({
  question,
  period,
  summary,
  rows,
  table,
}: {
  question: string;
  period?: string;
  summary?: string;
  rows: DivergingRow[];
  table?: TableTwin;
}) {
  const max = Math.max(1, ...rows.map((row) => Math.abs(row.value)));
  const zero = 50; // percent of the track
  return (
    <Figure question={question} period={period} summary={summary} table={table}>
      <div className="diverge">
        {rows.map((row) => {
          const width = (Math.abs(row.value) / max) * 50;
          const positive = row.value >= 0;
          return (
            <div className="drow" key={row.label}>
              <span className="t2">{row.label}</span>
              <span className="dtrack">
                <span className="dzero" style={{ insetInlineStart: `${zero}%` }} />
                <span
                  className={`dbar ${positive ? 'pos' : 'neg'}`}
                  style={positive ? { insetInlineStart: `${zero}%`, width: `${width}%` } : { insetInlineEnd: `${100 - zero}%`, width: `${width}%` }}
                />
              </span>
              <span className="dval num">{fmtMoney(row.value, 0, true)}</span>
            </div>
          );
        })}
      </div>
    </Figure>
  );
}
